// extracted by mini-css-extract-plugin
module.exports = {"shareIcons":"index_shareIcons__u59e2","IconItem":"index_IconItem__UV4RV"};